const state = {
  error: null,
  user: null,
};

const getters = {
  getAuthUser: (state) => state.user,
  getAuthError: (state) => state.error,
};

const actions = {
  authLogin({commit}, {email, password}) {
    return window.axios.post('/api/auth/login', {
      email,
      password,
    }).then((response) => {
      return window.axios.post('/api/auth/account').then((response) => {
        // console.log(response);
        commit('SET_AUTH_USER', response.data.user);
        // window.location.reload();
        window.location = response.data.redirect;
      });
    }, (error) => {
      window.app.sweetalert('Oops!', error.response.data.message, 'error');
      commit('SET_AUTH_ERROR', error.response.data.message);
      // The fields the server refused (e.g. an unknown email), for a form that shows field errors.
      return {errors: error.response.data.errors || {}};
    });
  },
  authLogout({commit}) {
    window.axios.post('/api/auth/logout').then((response) => {
      commit('SET_AUTH_USER', null);
      if (window.location.pathname == '/') {
        window.location.reload();
      } else {
        window.location = '/';
      }
    }, (response) => {
      commit('SET_AUTH_ERROR', response.data);
    });
  },
};

const mutations = {
  SET_AUTH_USER(state, user) {
    state.user = user;
  },
  SET_AUTH_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
